var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#7367F0",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 33.6C14.5 33.9 15 34 15.5 34H32.5C33.3 34 34 33.7 34.5 33.1C35.1 32.6 35.4 31.8 35.4 31C35.4 30.5 35.3 30 35 29.5L26.6 15.4C26.1 14.7 25.5 14.2 24.7 14C23.9 13.8 23.1 13.9 22.4 14.3C22 14.5 21.6 14.9 21.4 15.3L12.9 29.5C12.1 30.9 12.6 32.8 14 33.6ZM14.7 30.5L23.1 16.4C23.2 16.2 23.3 16.1 23.5 16C24 15.8 24.6 15.9 24.9 16.4L33.3 30.5C33.4 30.7 33.4 30.8 33.4 31C33.4 31.3 33.3 31.5 33.1 31.7C32.9 31.9 32.7 32 32.4 32H15.5C15.4 32 15.2 32 15.1 31.9C14.6 31.6 14.4 31 14.7 30.5ZM25 25V21C25 20.4 24.6 20 24 20C23.4 20 23 20.4 23 21V25C23 25.6 23.4 26 24 26C24.6 26 25 25.6 25 25ZM25 29C25 29.3 24.9 29.5 24.7 29.7C24.5 29.9 24.3 30 23.9 30C23.6 30 23.4 29.9 23.2 29.7C23 29.5 22.9 29.3 22.9 29C22.9 28.8829 22.9343 28.8 22.9627 28.7314C22.9828 28.6829 23 28.6414 23 28.6C23 28.5 23.1 28.4 23.2 28.3C23.3 28.2 23.4 28.1 23.5 28.1C23.7 28 23.9 28 24.1 28C24.1575 28.0575 24.1819 28.082 24.2113 28.0923C24.2331 28.1 24.2575 28.1 24.3 28.1C24.35 28.1 24.375 28.125 24.4 28.15C24.425 28.175 24.45 28.2 24.5 28.2C24.6 28.2 24.7 28.3 24.7 28.3C24.8 28.4 24.9 28.5 24.9 28.6C25 28.7 25 28.9 25 29Z",
    fill: "#7367F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b1ae64e0ee285081303caf6fc0531531.svg";
export { ForwardRef as ReactComponent };